/**
 * How the segment detail surface writes a stored figure.
 *
 * <p>One module because the grid's cells, the pinned Total / Unallocated rows beneath them and the
 * reconciliation bar under those all state the same figures. Two spellings across those three would read as two
 * different values rather than as one value formatted twice.
 */

/**
 * Fraction digits to allow. `Intl.NumberFormat`'s own ceiling under the spec these browsers implement, and
 * beyond what a double can distinguish anyway, so it never truncates a stored value.
 */
export const MAX_FRACTION_DIGITS = 20;

/**
 * A stored number, grouped per the runtime locale and **in full**.
 *
 * <p>`toLocaleString()` on its own defaults to three fraction digits, which silently rounds the figures this
 * feature exists to show: a stored allocation percentage of `0.0010958454` rendered as `0.001`, and
 * `0.0009050352` rendered as `0` — a value displayed as nothing. Since these cells are what a reviewer
 * reconciles against the GL, a rounded figure that looks exact is worse than an obviously long one.
 *
 * <p>The cap is a ceiling, not a pad: there is no `minimumFractionDigits`, so an integer still renders as an
 * integer (`67`, not `67.00000000000000000000`) and only a value that has fraction digits shows them.
 */
export function formatFullNumber(value: number): string {
    return value.toLocaleString(undefined, { maximumFractionDigits: MAX_FRACTION_DIGITS });
}
